// src/i18n/en/lockerAssignments.js
const lockerAssignments = {
    name: 'Locker Assignment |||| Locker Assignments',
    titles: {
        list: 'Locker Assignments',
        create: 'Create New Assignment',
        edit: 'Edit Assignment',
        show: 'Assignment Details',
        details: 'View details'
    },
    edit: {
        success: 'Assignment updated successfully'
    },
    fields: {
        displayReference: 'Reference',
        guestName: 'Guest Name',
        guestEmail: 'Guest Email',
        guestPhone: 'Guest Phone',
        roomNumber: 'Room Number',
        checkInDate: 'Check-in Date',
        checkOutDate: 'Check-out Date',
        status: 'Status',
        startsAt: 'Starts At',
        expiresAt: 'Expires At',
        completedAt: 'Completed At',
        assignedLockers: 'Assigned Lockers',
        notes: 'Notes',
        hotel: 'Hotel',
        createdBy: 'Created by',
        createdAt: 'Created at',
        updatedAt: 'Last updated',
        zone: 'Zone',
        no_zone: 'No zone',
        available_lockers: 'Available lockers',
        recommended: 'Recommended',
        requestedTypes: 'Requested Types',
        dates: 'Dates',
        tags: 'Tags',
        usage: 'Usage'
    },
    filters: {
        search: 'Search'
    },
    status: {
        pending: 'Pending',
        active: 'Active',
        completed: 'Completed',
        cancelled: 'Cancelled',
        expired: 'Expired',
        archived: 'Archived'
    },
    actions: {
        title: 'Actions',
        view: 'View details',
        edit: 'Edit',
        delete: 'Delete',
        archive: 'Archive',
        assign_physical: 'Assign lockers',
        view_access_logs: 'View access logs',
        more_actions: 'More actions',
        assignLockers: 'Assign Lockers',
        archive_and_release: 'Archive and Release',
        assign: 'Assign'
    },
    sections: {
        hotel_info: 'Hotel Information',
        guest_info: 'Guest Information',
        requested_types: 'Requested Locker Types',
        assignment_period: 'Assignment Period',
        additional_references: 'Additional References',
        general_info: 'General Information',
        assignment_status: 'Assignment Status',
        assigned_lockers_physical: 'Physically Assigned Lockers'
    },
    dialogs: {
        delete_title: 'Confirm deletion',
        delete_content: 'Are you sure you want to delete this assignment? This action cannot be undone.',
        confirm: 'Confirm',
        cancel: 'Cancel',
        delete_message: 'Are you sure you want to delete this assignment? This action cannot be undone.',
        archive_title: 'Confirm archive',
        archive_message: 'Are you sure you want to archive this assignment?',
        archive_active_title: 'Archive active assignment',
        archive_active_message: 'This assignment is active. Are you sure you want to archive it?',
        assign_title: 'Assign Lockers'
    },
    buttons: {
        add_type: 'Add Type',
        add_reference: 'Add Reference',
        remove: 'Remove'
    },
    labels: {
        locker_type: 'Locker Type',
        quantity: 'Quantity',
        key: 'Key',
        value: 'Value',
        reference: 'Reference',
        zone: 'Zone',
        type: 'Type',
        no_assigned_lockers: 'No assigned lockers',
        locker_count: '%{count} locker',
        locker_count_plural: '%{count} lockers',
        no_zone: 'No zone',
        no_type: 'No type',
        requested: 'Requested',
        assigned: 'Assigned'
    },
    messages: {
        no_hotel_selected: 'No hotel selected',
        select_hotel_message: 'Please select a hotel from the top selector to create an assignment.',
        must_add_locker_type: 'You must add at least one locker type',
        loading_locker_types: 'Loading locker types...',
        no_locker_types_configured: 'No locker types configured for this hotel',
        
        // LockerRequirementsSection specific translations
        locker_requirements_title: 'Locker Requirements',
        must_request_locker_help: '* Must request at least one locker',
        
        // ZonesSection specific translations
        zones_title: 'Allowed Zones',
        loading_zones: 'Loading zones...',
        no_zones_configured: 'No zones configured for this hotel',
        select_zones_label: 'Select zones',
        zones_selected_count: '%{selected} of %{total} zones selected',
        
        // NotesSection specific translations
        notes_title: 'Additional Notes',
        notes_placeholder: 'Observations',
        
        add_at_least_one_type: 'Add at least one locker type for the assignment',
        assignment_not_editable: 'This assignment cannot be edited because its status is:',
        archived_successfully: 'Assignment archived successfully',
        deleted_successfully: 'Assignment deleted successfully',
        creation_error: 'Error creating assignment',
        update_error: 'Error updating assignment',
        archive_error: 'Error archiving assignment',
        delete_error: 'Error deleting assignment',
        delete_success: 'Assignment deleted successfully',
        archive_success: 'Assignment archived successfully',
        assign_success: 'Lockers assigned successfully',
        assign_error: 'Error assigning lockers',
        fetch_lockers_error: 'Error fetching lockers',
        no_lockers_available: 'No lockers available',
        loading_lockers: 'Loading lockers...',
        no_availability: 'No lockers available to assign at this time',
        need_have: 'Need %{need}, available %{have}',
        requested: 'Requested',
        available: 'Available',
        available_count: 'Available: %{count}',
        select_at_least_one: 'Select at least one locker',
        assigning: 'Assigning...'
    },
    validation: {
        required: 'This field is required',
        invalid_email: 'Invalid email',
        invalid_phone: 'Invalid phone',
        invalid_dates: 'Check-out date must be after check-in date',
        no_types: 'Must request at least one locker type',
        no_quantities: 'Must request at least one locker'
    },
    notifications: {
        load_lockers_error: 'Error loading available lockers',
        lockers_assigned_success: 'Lockers assigned successfully'
    },
    common: {
        not_assigned: 'Not assigned'
    },
    tooltips: {
        more_actions: 'More actions'
    },
    assignment: {
        automatic: 'Automatic',
        manual: 'Manual'
    },
    placeholders: {
        select_lockers: 'Select lockers'
    },
    helpers: {
        selected_count: 'Selected: %{count}'
    },
    ui: {
        locker_count: '%{count} locker||||%{count} lockers',
        minutes_ago: '%{count} minute ago||||%{count} minutes ago',
        hours_ago: '%{count} hour ago||||%{count} hours ago',
        days_ago: '%{count} day ago||||%{count} days ago',
        access_count: '%{count} access||||%{count} accesses',
        yesterday: 'yesterday',
        last_access: 'Last access',
        no_name: 'No name'
    },
    tags: {
        loading_error: 'Error loading tags',
        assignment: 'Assignment',
        manage: 'Manage',
        manage_title: 'Manage Tags',
        no_tags_message: 'No tags associated with this assignment',
        no_tags_yet: 'No tags yet',
        current_tags: 'Current Tags',
        add_new: 'Add New',
        tag_type: 'Tag Type',
        tag_code: 'Tag Code',
        enter_code: 'Enter tag code',
        code_help: 'Enter the unique tag code',
        description: 'Description',
        description_placeholder: 'Optional tag description',
        description_help: 'Optional tag description',
        add_tag: 'Add Tag',
        auto_generated: 'Auto Generated',
        generating_qr: 'Generating QR code...',
        loading_types: 'Loading tag types...',
        added_on: 'Added on %{date}',
        
        // TagsSection translations
        access_tags_count: 'Access Tags (%{count})',
        no_access_tags: 'No access tags added',
        add_id: 'Add ID',
        
        // Tags from TagsPopover - additional translations
        archived_no_edit: 'Cannot manage tags on archived assignments',
        add_tags: 'Add Tag',
        code_copied: 'Code copied to clipboard',
        error_copying: 'Error copying code',
        active: 'Active',
        inactive: 'Inactive',
        
        // Success messages
        added_successfully: 'Tag added successfully',
        removed_successfully: 'Tag removed successfully',
        
        // Error messages
        error_empty_code: 'Tag code is required',
        error_no_type_selected: 'Must select a tag type',
        error_adding: 'Error adding tag',
        error_removing: 'Error removing tag'
    },
    access_history: {
        title: 'Access History',
        accesses: 'accesses',
        last: 'Last',
        no_access: 'No access records found',
        loading_error: 'Error loading access history',
        error_loading: 'Failed to load access history',
        showing_recent: 'Showing %{shown} of %{total} recent accesses',
        action: {
            opened: 'Opened',
            closed: 'Closed',
            denied: 'Denied',
            locker_opened: 'Locker Opened',
            locker_closed: 'Locker Closed',
            locker_denied: 'Locker Access Denied',
            first_use_assigned: 'First Use'

        }
    }
};

module.exports = { lockerAssignments };